import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Register: React.FC = () => {
  const nav = useNavigate();
  const { register } = useAuth();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      await register(username, email, password);
      nav('/plots');
    } catch (err: any) {
      setError(err?.message || 'Registration failed');
    }
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="w-full max-w-sm">
        <div className="p-6 rounded-2xl bg-gradient-to-b from-gray-900/80 via-gray-900/70 to-gray-900/80 border border-gray-800 shadow-xl">
          <div className="flex items-center gap-2 mb-4">
            <i className="fas fa-seedling text-green-400"></i>
            <h2 className="text-xl font-semibold">Create your AuraFarm account</h2>
          </div>
          <p className="text-sm text-gray-400 mb-4">Register to manage plots, trade on the market, and grow your tycoon.</p>
          {error && (
            <div className="mb-3 px-3 py-2 rounded bg-red-900/30 border border-red-700 text-red-300 text-sm">
              {error}
            </div>
          )}
          <form className="space-y-3" onSubmit={onSubmit}>
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Username</label>
              <input className="w-full px-3 py-2 rounded-lg bg-gray-800 text-white border border-gray-700 outline-none focus:border-green-500" placeholder="FarmerJoe" value={username} onChange={(e) => setUsername(e.target.value)} />
            </div>
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Email</label>
              <input className="w-full px-3 py-2 rounded-lg bg-gray-800 text-white border border-gray-700 outline-none focus:border-green-500" placeholder="you@farm.com" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <label className="text-xs text-gray-400 mb-1 block">Password</label>
              <input className="w-full px-3 py-2 rounded-lg bg-gray-800 text-white border border-gray-700 outline-none focus:border-green-500" placeholder="••••••••" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <button className="w-full px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-500 font-medium">Join AuraFarm</button>
          </form>
          <div className="mt-4 text-xs text-gray-400 flex items-center justify-between">
            <span>Already have an account?</span>
            <Link to="/login" className="text-green-300 hover:text-green-200">Sign in</Link>
          </div>
        </div>
        <div className="mt-3 text-center text-xs text-gray-500">Secure login · Sustainable growth</div>
      </div>
    </div>
  );
};

export default Register;